export const ru = {
  // Navigation
  nav: {
    home: "Главная",
    services: "Услуги",
    about: "О нас",
    contact: "Контакт",
    implants: "Имплантаты",
    veneers: "Виниры",
    composite: "Композитная реставрация",
    technology: "Технологии",
    emergency: "Экстренная помощь 24/7",
    legalNotice: "Юридическая информация",
    close: "Закрыть",
    bookNow: "Записаться сейчас",
    book: "Записаться сейчас"
  },

  // Common labels used across the app
  common: {
    bookNow: "Записаться",
    learnMore: "Узнать больше",
    getDirections: "Маршрут",
    phone: "Телефон",
    email: "Email",
    date: "Дата",
    time: "Время",
    close: "Закрыть"
  },

  // Header
  header: {
    logoText: "SeaDent Mallorca",
    phone: "603 31 96 48",
    whatsapp: "WhatsApp",
    languageToggle: "RU",
    reviews: {
      rating: "5.0",
      count: "470+ отзывов",
      google: "Отзывы в Google"
    }
  },

  // Hero Section
  hero: {
    title: "SeaDent Майорка: Ваша улыбка имеет значение.",
    subtitle: "Современная стоматология с эмпатией.",
    cta: "Записаться на прием",
    makeover: {
      title: "Smile Makeover с композитом",
      subtitle: "Прямая послойная техника от руки – минимально инвазивно и естественно красиво.",
      cta: "Узнать больше"
    },
    rotation: {
      on: "Вращение: вкл",
      off: "Вращение: выкл"
    },
    scrollMore: "Узнать больше",
    banner: {
      title: "Почувствуйте индивидуальный комфорт",
      subtitle: "(и узнайте, почему наши пациенты любят возвращаться)",
      buttons: {
        cosmetic: "Эстетическая стоматология",
        pediatric: "Детская стоматология",
        general: "Общая стоматология",
        whitening: "Отбеливание зубов"
      }
    }
  },

  // Booking Wizard (3-step flow)
  bookingWizard: {
    steps: {
      treatment: "Какой тип приема вам необходим?",
      insurance: "Как вы хотите оплатить?",
      dateTime: "Выберите предпочтительную дату и время"
    },
    treatments: {
      cleaning: "Профессиональная чистка зубов + осмотр (врач)",
      returningCleaning: "Чистка Зубов для Повторного Пациента (Регистрированный Стоматолог-Гигиенист) + Осмотр (Врач)",
      consultation: "Общая Стоматологическая Консультация (Врач)",
      cosmetic: "Эстетическая Стоматологическая Консультация (Врач)",
      secondOpinion: "Консультация Второго Мнения в Стоматологии (Врач)",
      emergency: "Срочный Стоматологический Прием (Рентген + Осмотр Врача)",
      whitening: "Профессиональное Отбеливание Зубов",
      botox: "Консультация по Ботоксу (Врач)",
      tmj: "Консультация по ВНЧС (Боль в Челюсти) (Врач)",
      pediatric: "Детская стоматология"
    },
    insurance: {
      search: "Введите вашу страховку",
      privatePay: "Частная оплата",
      privatePayDesc: "Самостоятельная оплата · страховка не требуется",
      withInsurance: "Через мою страховку",
      withInsuranceDesc: "Укажите название страховки"
    },
    navigation: {
      back: "Назад",
      next: "Далее",
      close: "Закрыть"
    },
    getDirections: "Маршрут",
    instantBookingBy: "Мгновенное бронирование через"
  },

  // Form structure used in Step 3 and elsewhere
  booking: {
    title: "Запись на прием",
    subtitle: "Запланируйте визит к нашей команде экспертов",
    form: {
      name: "Полное имя",
      email: "Электронная почта",
      phone: "Номер телефона",
      message: "Сообщение (необязательно)",
      submit: "Подтвердить бронирование",
      submitting: "Отправка...",
      success: "Спасибо! Ваша запись была подтверждена.",
      error: "Произошла ошибка при бронировании. Пожалуйста, попробуйте еще раз."
    }
  },

  // Contact Page content
  contact: {
    title: "Свяжитесь с нами",
    subtitle: "Мы рады ответить на ваши вопросы",
    contactInfo: "Контактная информация",
    phone: "Телефон",
    address: "Адрес",
    email: "Электронная почта",
    emergencyTitle: "Неотложная помощь",
    emergencyText: "Для экстренных случаев доступна круглосуточная служба",
    appointment: "Запись на прием",
    findUsTitle: "Где нас найти",
    directionsButton: "Показать маршрут",
    transportTitle: "Как добраться",
    publicTransport: "Общественный транспорт",
    publicTransportInfo: "Мы находимся в самом центре Пальмы, рядом с основными автобусными остановками на Jaime III.",
    byCar: "На автомобиле",
    byCarInfo: "Поблизости есть несколько общественных парковок, включая Parking Vía Roma и El Corte Inglés."
  },

  // Footer
  footer: {
    links: {
      title: "Навигация",
      home: "Главная",
      contact: "Контакт",
      book: "Записаться"
    },
    contact: {
      title: "Контактная информация",
      practice: "SeaDent Mallorca",
      address: "Avenida de Jaime III № 3",
      city: "07012 Пальма-де-Майорка",
      owner: "Inhaber: Jan D. Heiringhoff",
      phone: "603 31 96 48",
      whatsapp: "WhatsApp: 603 31 96 48",
      email: "info@seadent.es",
      hours: "Пн-Пт: 09:00 - 18:00"
    },
    legal: {
      title: "Юридическая информация",
      privacy: "Политика конфиденциальности",
      cookieSettings: "Настройки файлов cookie"
    },
    copyright: "© {year} SeaDent Майорка. Все права защищены."
  },

  // Cookie Consent
  cookieConsent: {
    title: "Настройки файлов cookie",
    description: "Мы используем файлы cookie для улучшения вашего опыта. Используя наш сайт, вы соглашаетесь с нашей политикой использования файлов cookie.",
    acceptAll: "Принять все",
    acceptNecessary: "Только необходимые",
    settings: "Настройки",
    save: "Сохранить настройки",
    close: "Закрыть",
    privacyPolicy: "Политика конфиденциальности",
    categories: {
      necessary: {
        title: "Необходимые",
        description: "Эти файлы cookie необходимы для работы веб-сайта и не могут быть отключены."
      },
      preferences: {
        title: "Предпочтения",
        description: "Эти файлы cookie позволяют веб-сайту запоминать сделанный вами выбор."
      },
      statistics: {
        title: "Статистика",
        description: "Эти файлы cookie помогают нам понять, как посетители взаимодействуют с веб-сайтом."
      },
      marketing: {
        title: "Маркетинг",
        description: "Эти файлы cookie используются для предоставления посетителям релевантной рекламы и маркетинговых кампаний."
      }
    }
  },

  // Emergency Page
  emergency: {
    title: "Круглосуточная экстренная стоматологическая помощь 24/7",
    subtitle: "Мы здесь, чтобы помочь вам 24 часа в сутки",
    intro: "Если вам требуется экстренная стоматологическая помощь, немедленно свяжитесь с нами. Наша команда специалистов по неотложной помощи работает круглосуточно, чтобы обеспечить вам необходимый уход.",
    call: "Позвонить сейчас",
    whatsapp: "WhatsApp",
    cta: "Звоните: 603 31 96 48",
    details: [
      {
        title: "Доступность",
        description: "Наша команда экстренной помощи работает 24 часа в сутки, 365 дней в году, включая выходные и праздничные дни."
      },
      {
        title: "Контакт",
        description: "Свяжитесь с нами по телефону 603 31 96 48 для получения немедленной помощи. Мы также принимаем сообщения через WhatsApp."
      },
      {
        title: "Типичные экстренные случаи",
        description: "Мы лечим сильную зубную боль, переломы зубов, вывихи зубов и другие стоматологические травмы."
      },
      {
        title: "Сервис",
        description: "Мы обеспечиваем немедленное облегчение боли и долгосрочные решения, используя новейшие стоматологические технологии."
      }
    ],
    common: {
      title: "Типичные экстренные случаи",
      toothache: "Сильная зубная боль",
      broken: "Сломанный или отколотый зуб",
      knocked: "Выбитый зуб",
      bleeding: "Кровоточивость десен",
      swelling: "Отек лица",
      lost: "Выпавшая пломба или коронка",
      // === Общие ключи страниц неотложной помощи (SEO-контракт) ===
      breadcrumbHome: "Неотложная помощь",
      callNow: "Позвонить сейчас: 603 31 96 48",
      whatsappCta: "В WhatsApp: отправьте нам фото",
      bookOnline: "Записаться онлайн",
      backToHub: "Все экстренные случаи: стоматологическая неотложная помощь в Пальме",
      locationLine: "Avenida de Jaime III, 3 · 07012 Пальма-де-Майорка — парковки Vía Roma и El Corte Inglés в двух минутах ходьбы.",
      calloutReviews: "5.0 ★ в Google — более 470 отзывов",
      authorBox: {
        label: "Медицинская проверка содержания",
        name: "Jan David Heiringhoff",
        credential: "Col·legiat № 07001232 — Col·legi Oficial de Dentistes de Balears",
        reviewedLabel: "Проверено врачом:",
        reviewedDate: "Обновлено: июль 2026",
      },
      midCta: {
        title: "Позвоните — мы в самом центре Пальмы",
        body: "Avenida de Jaime III, 3, парковки Vía Roma и El Corte Inglés рядом. Мы перезвоним в течение 30 минут — приём и консультация на немецком, английском и испанском языках.",
        button: "603 31 96 48",
      },
    },
    // === Редизайн v2 (redesign emergency/DESIGN.md) ===
    v2: {
      heroBadge: "ДОСТУПНО СЕЙЧАС • 24/7",
      heroAccent: "Мы здесь, чтобы Вам помочь.",
      heroIntro: "При сильной боли, травме или сломанном зубе наша команда экстренной помощи оказывает немедленное и чуткое лечение — 365 дней в году.",
      callBtn: "ПОЗВОНИТЬ: 603 31 96 48",
      whatsappBtn: "WHATSAPP",
      stats: {
        availability: "Доступность",
        daysAYear: "Дней в году",
        responseTime: "Время реакции",
        rating: "Оценка пациентов",
      },
      common: {
        title: "Распространённые экстренные случаи",
        intro: "Быстрое лечение важно для долгосрочного здоровья зубов. Мы оказываем неотложную стоматологическую помощь на высшем уровне.",
        eyebrow: "Экспертная помощь в Пальме",
        cards: [
          {
            title: "Сильная зубная боль",
            description: "Пульсирующая или резкая боль часто говорит об инфекции или поражении нерва — нужна срочная помощь.",
            checks: ["Срочная диагностика", "Лечение каналов"],
          },
          {
            title: "Травма зуба",
            description: "Сломанные, отколотые или выбитые зубы после травмы требуют быстрых действий, чтобы спасти зуб.",
            checks: ["Срочная реконструкция", "Реплантация"],
          },
          {
            title: "Абсцесс и инфекция",
            description: "Отёк и температура — признаки серьёзной инфекции, нужны антибиотики или хирургическое вмешательство.",
            checks: ["Дренаж инфекции", "Снятие боли"],
          },
        ],
      },
      process: {
        title: "Что делать при экстренной ситуации?",
        steps: [
          {
            title: "Сразу позвоните",
            description: "Наберите 603 31 96 48 без промедления и кратко опишите симптомы — мы подготовимся к Вашему приезду.",
          },
          {
            title: "Первая помощь",
            description: "При боли охлаждайте снаружи. При сколе зуба — храните фрагмент в молоке или слюне.",
          },
          {
            title: "Приходите в клинику",
            description: "Avenida de Jaime III № 3, Пальма — центральное расположение для быстрого доступа.",
          },
        ],
      },
      location: {
        eyebrow: "Наша клиника",
        title: "SeaDent Mallorca",
        intro: "В самом центре Пальмы — средиземноморская атмосфера в сочетании с современнейшей медицинской техникой.",
        addressLine1: "Avenida de Jaime III № 3",
        addressLine2: "07012 Palma de Mallorca",
        hoursLabel: "Пн – Пт: 09:00 – 18:00",
        emergencyHours: "Телефон экстренной помощи: 24/7",
        directions: "Как добраться",
      },
      finalCta: {
        title: "Мы здесь, чтобы Вам помочь.",
        intro: "Зубная боль изматывает. Наша чуткая команда готова дать быстрое облегчение и высокую квалификацию — Ваша улыбка в надёжных руках.",
        button: "ЭКСТРЕННО: 603 31 96 48",
      },
    },

    // === Notfall-SEO-Offensive: Hub-Upgrade (Kontrakt) ===
    triage: {
      title: "Когда звонить немедленно?",
      intro: "Не каждая ситуация одинаково срочна — но некоторые не терпят отлагательств. Сориентируйтесь по трём уровням, а если сомневаетесь — просто позвоните: мы оценим ситуацию по телефону, это ни к чему не обязывает.",
      levels: [
        {
          tone: 'now' as const,
          label: "Звоните немедленно",
          items: [
            "Зуб выбит целиком — счёт идёт на минуты",
            "Отёк лица, температура или затруднённое глотание",
            "Кровотечение после травмы или удаления, которое не останавливается",
            "Невыносимая зубная боль, которую не снимают безрецептурные средства",
          ],
        },
        {
          tone: 'today' as const,
          label: "Приём сегодня",
          items: [
            "Сломался зуб или откололся фрагмент",
            "Пульсирующая боль, которая нарастает, либо резкая реакция на холодное и горячее",
            "Выпала пломба, коронка или винир — зуб остался без защиты",
            "Боль или воспаление вокруг имплантата",
          ],
        },
        {
          tone: 'week' as const,
          label: "На этой неделе",
          items: [
            "Небольшой скол или трещинка без боли",
            "Лёгкая периодическая чувствительность при жевании",
            "Точечная кровоточивость дёсен при чистке зубов",
          ],
        },
      ],
    },
    hubCards: {
      title: "Что у вас случилось? Найдите свою ситуацию",
      cards: [
        {
          icon: "sick",
          title: "Острая зубная боль",
          teaser: "Пульсирующая боль, которая будит по ночам, обычно говорит о воспалении нерва — само оно не пройдёт. Чем раньше мы начнём, тем проще спасти зуб.",
          linkText: "Острая зубная боль — что делать?",
          routeKey: "emergency-toothache",
        },
        {
          icon: "dentistry",
          title: "Сломался или выбит зуб",
          teaser: "В большинстве случаев мы восстанавливаем зуб композитом в тот же день. Если зуб выбит целиком, решают первые 60 минут.",
          linkText: "Сломался зуб — что делать?",
          routeKey: "emergency-broken-tooth",
        },
        {
          icon: "emergency",
          title: "Флюс или опухла щека",
          teaser: "Флюс — это инфекция, которая не проходит сама. При отёке, температуре или затруднённом глотании действовать нужно сегодня.",
          linkText: "Флюс — почему действовать нужно сегодня",
          routeKey: "emergency-abscess",
        },
        {
          icon: "luggage",
          title: "Зубная боль в отпуске",
          teaser: "Вы на Майорке в отпуске, и разболелся зуб? Мы принимаем без направления: письменная смета, подробный счёт и отчёт для вашего стоматолога дома.",
          linkText: "Зубная боль в отпуске — пошаговый план действий",
          routeKey: "emergency-tourists",
        },
        {
          icon: "child_care",
          title: "Зубная травма у ребёнка",
          teaser: "Падение в бассейне или с велосипеда, повреждён зуб — сохраняйте спокойствие. Важно: молочный зуб никогда не вставляют обратно.",
          linkText: "Сломался зуб у ребёнка — первые правильные шаги",
          routeKey: "emergency-broken-tooth",
        },
      ],
    },
    weekend: {
      title: "На связи и в выходные, и в праздники, и ночью",
      paragraphs: [
        "Зубная боль не смотрит в календарь. Поэтому наш телефон неотложной помощи работает круглосуточно, 7 дней в неделю — в том числе в воскресенье, в праздничные дни и глубокой ночью. Позвоните по номеру 603 31 96 48 или напишите в WhatsApp: мы перезвоним в течение 30 минут и вместе решим, что делать дальше.",
        "Сама клиника на Avenida de Jaime III, 3 в Пальме открыта с понедельника по пятницу с 9:00 до 18:00. Вне этих часов и в выходные мы принимаем экстренных пациентов по телефонной договорённости: вы звоните — мы организуем приём. Так вы не потеряете время у закрытой двери.",
        "При настоящей угрозе жизни — высокая температура, затруднённое дыхание или глотание — сначала звоните в службу спасения 112 (на Балеарских островах — 061), а затем нам.",
      ],
    },
    hubSolve: {
      title: "Как мы решаем проблему в SeaDent",
      items: [
        {
          problem: "Сломался или откололся зуб",
          solution: "Прямая композитная реставрация за один визит: послойная техника от руки, без обточки зуба — результат виден в тот же день.",
          linkText: "Композитная реставрация за один визит",
          routeKey: "composite",
        },
        {
          problem: "Острая зубная боль",
          solution: "Диагностика с цифровым рентгеном и экстренное лечение каналов под дентальным микроскопом, лазер для стерилизации каналов. Мы всегда стараемся сохранить ваш зуб.",
          linkText: "Наши технологии: микроскоп, лазер и 3D-рентген",
          routeKey: "technologies",
        },
        {
          problem: "Проблема с имплантатом",
          solution: "Цифровая диагностика и компьютерное планирование — даже если имплантат ставили в другой клинике. Мы заново фиксируем коронки и лечим воспаление.",
          linkText: "Имплантаты в SeaDent",
          routeKey: "implants",
        },
      ],
    },
    hubFaq: {
      title: "Частые вопросы о неотложной помощи",
      items: [
        {
          q: "Сколько стоит срочный приём?",
          a: "Стоимость зависит от того, какое лечение вам нужно. Сначала осмотр и диагноз, затем — письменная смета до начала лечения, без сюрпризов. Оплатить можно картой, а подробный счёт подойдёт для вашей страховой компании.",
        },
        {
          q: "Вы принимаете в воскресенье и в праздники?",
          a: "Телефон неотложной помощи отвечает круглосуточно — и в воскресенье, и в праздники. Приём вне часов работы клиники (пн–пт 9:00–18:00) организуется по телефонной договорённости. Позвоните по номеру 603 31 96 48 — мы перезвоним в течение 30 минут.",
        },
        {
          q: "Откололась или отклеилась коронка — вы поможете?",
          a: "Да. В зависимости от ситуации мы фиксируем коронку заново, ремонтируем её композитом или изготавливаем новую по цифровому слепку. Если коронка у вас на руках — привезите её в чистом пакетике и не приклеивайте самостоятельно.",
        },
        {
          q: "Болит имплантат, который ставили в другой стране. Вы возьмётесь?",
          a: "Конечно. Мы лечим осложнения и на имплантатах, установленных в других клиниках и странах. С помощью цифрового 3D-рентгена и компьютерного планирования мы находим причину, заново фиксируем расшатавшиеся коронки и лечим воспаление тканей вокруг имплантата.",
        },
        {
          q: "Вы делаете экстренное лечение корневых каналов?",
          a: "Да. При воспалении нерва экстренное лечение каналов часто — единственный способ остановить боль и сохранить зуб. Мы работаем под дентальным микроскопом и используем лазер для стерилизации каналов — это заметно повышает шансы на успех.",
        },
        {
          q: "Кровоточат дёсны — это экстренный случай?",
          a: "Точечная кровоточивость при чистке — обычно не экстренный случай, но сигнал, что дёснам нужен осмотр. Если кровотечение сильное, сопровождается отёком или болью либо не останавливается после удаления зуба — звоните нам сегодня же.",
        },
        {
          q: "Говорите ли вы по-русски?",
          a: "Нет, приём и консультация проходят на немецком, английском и испанском языках. Опишите жалобы и приложите фото по WhatsApp — так мы поймём ситуацию ещё до вашего звонка.",
        },
      ],
    },
    homeTeaser: {
      title: "Зубная боль? Телефон неотложной помощи — 24/7",
      body: "Острая боль, сломанный зуб или флюс: SeaDent Mallorca поможет — в выходные и праздники приём по телефонной договорённости. Позвоните по номеру 603 31 96 48 — мы перезвоним в течение 30 минут. Приём и консультация на немецком, английском и испанском языках.",
      linkText: "Стоматологическая неотложная помощь в Пальме — вся информация",
    },
    footerTitle: "Неотложная помощь",

    // === Spoke-Seiten (Kontrakt: SpokeContent) ===
    brokenTooth: {
      breadcrumb: "Сломался зуб",
      h1: "Сломался зуб на Майорке? Мы можем его восстановить — срочная помощь в Пальме",
      heroIntro: "Это больно, пугает и всегда случается не вовремя — сделайте вдох: почти для любой зубной травмы есть хорошее решение, часто в тот же день. В большинстве случаев мы восстанавливаем зуб за один визит — без коронки и без обточки.",
      heroNote: "Отправьте нам фото зуба в WhatsApp — мы сразу скажем, что делать.",
      warnbox: {
        title: "Зуб выбит целиком? Решают первые 60 минут",
        body: "Выбитый зуб имеет наилучшие шансы прижиться, если вернуть его на место в течение первых 60 минут. Положите зуб в молоко или держите в собственной слюне — и звоните нам по дороге к нам: 603 31 96 48. Мы подготовим всё к вашему приезду.",
      },
      sections: [
        {
          icon: "healing",
          title: "Первая помощь: 4 шага, которые спасают зуб",
          intro: "То, что вы сделаете в ближайшие минуты, может решить судьбу зуба. Выполните эти четыре шага — и параллельно позвоните нам.",
          items: [
            {
              title: "1. Положите зуб или осколок в молоко или слюну",
              body: "Холодное молоко — лучшая доступная среда для перевозки зуба; подойдёт и собственная слюна (например, за щекой у взрослого). Ещё лучше — специальный контейнер для спасения зуба из аптеки, если он есть под рукой. Никогда не перевозите зуб сухим и не кладите его в воду.",
            },
            {
              title: "2. Берите зуб только за коронку",
              body: "Держите зуб только за белую видимую часть и никогда — за корень. На поверхности корня находятся живые клетки, без которых зуб не приживётся.",
            },
            {
              title: "3. Не чистите и не трите",
              body: "Даже если зуб упал на землю: не трите его, не дезинфицируйте и не удаляйте с него остатки тканей. То, что выглядит как грязь, может оказаться именно той тканью, которую нужно сохранить.",
            },
            {
              title: "4. Охлаждайте снаружи",
              body: "Холодный компресс через ткань на щёку снимает боль и сдерживает отёк. Не прикладывайте лёд напрямую к коже или к зубу.",
            },
          ],
        },
        {
          icon: "table_chart",
          title: "Сломался, выпал или шатается? Что это значит",
          intro: "Не всякая травма зуба одинакова. Эта таблица поможет за секунды понять вашу ситуацию:",
          table: {
            headers: ["Ситуация", "Что это значит", "Что делать", "Срочность"],
            rows: [
              [
                "Зуб сломался или откололся",
                "Отломился фрагмент; корень остался на месте",
                "Сохранить осколок в молоке или слюне и записаться на сегодня",
                "Сегодня",
              ],
              [
                "Зуб выбит целиком",
                "Зуб выпал полностью, вместе с корнем",
                "Положить в молоко или слюну, не трогать корень и звонить немедленно",
                "Сейчас — окно 60 минут",
              ],
              [
                "Зуб шатается или сместился",
                "Зуб подвижен или изменил положение после удара",
                "Не трогать языком, не накусывать; сегодня же на приём для шинирования",
                "Сегодня",
              ],
            ],
          },
        },
        {
          icon: "diamond",
          title: "Откололась коронка или винир?",
          intro: "Отклеившаяся коронка или сколотый винир — не только эстетическая проблема: зуб остаётся без защиты от температуры и бактерий. Привезите деталь, если она сохранилась, — в зависимости от случая мы зафиксируем коронку заново, отремонтируем винир композитом или снимем цифровой слепок для изготовления нового. До приёма не жуйте на этой стороне и ни в коем случае не приклеивайте коронку самостоятельно бытовым клеем.",
        },
      ],
      solve: {
        title: "Как мы решаем это в SeaDent: реставрация за один визит",
        intro: "Наша специализация — прямая композитная реставрация. «Мы умеем клеить» — и для сломанного зуба это идеальное решение:",
        points: [
          {
            title: "Результат в тот же день",
            body: "Мы восстанавливаем форму, длину и цвет зуба за одно посещение — послойной техникой от руки. Без лаборатории, без временных конструкций, без второго визита.",
          },
          {
            title: "Без обточки и обратимо",
            body: "Мы не стачиваем ваш натуральный зуб, а только добавляем материал. Все будущие варианты лечения остаются открытыми — а если позже снова отколется кусочек, мы отремонтируем точечно, без новой коронки.",
          },
          {
            title: "Реплантация и шинирование",
            body: "Если зуб выбит целиком, мы возвращаем его на место и стабилизируем шиной — с контролем под дентальным микроскопом. Именно поэтому важна каждая минута: звоните по дороге к нам.",
          },
        ],
        links: [
          { text: "Прямая композитная реставрация — как это работает", routeKey: "composite" },
          { text: "Зубная боль в отпуске на Майорке — расходы и оплата", routeKey: "emergency-tourists" },
        ],
      },
      faq: {
        title: "Частые вопросы: сломался зуб",
        items: [
          {
            q: "Сколько времени есть, чтобы спасти зуб?",
            a: "У полностью выбитого зуба наилучшие шансы — в первые 60 минут, если он правильно хранится в молоке или слюне. Отколовшийся фрагмент менее срочен, но чем раньше вы приедете, тем больше шансов использовать осколок или восстановить зуб без следа.",
          },
          {
            q: "Сколько стоит восстановление?",
            a: "Зависит от объёма повреждения и количества зубов. Перед началом лечения вы всегда получаете письменную смету, а после — подробный счёт для вашей страховой компании.",
          },
          {
            q: "А если это случилось у ребёнка? Что с молочным зубом?",
            a: "Важно: молочный зуб никогда не вставляют обратно — попытка реплантации может повредить зачаток постоянного зуба. Сохраняйте спокойствие, охладите место удара и позвоните нам — по телефону мы скажем, нужно ли приезжать сегодня. Если пострадал постоянный зуб (примерно с 6–7 лет), действуют те же правила, что и для взрослых: молоко или слюна — и немедленно к нам.",
          },
          {
            q: "Покроет ли лечение моя страховка?",
            a: "Мы выдаём подробный счёт с диагнозом и перечнем процедур, а при необходимости — рентгеновские снимки и заключение врача. С этими документами вы можете обратиться в свою страховую компанию; условия возмещения зависят от вашего полиса.",
          },
          {
            q: "Долговечна ли композитная реставрация?",
            a: "Да. При хорошей гигиене и регулярных осмотрах композитные реставрации служат много лет, а при повреждении отдельного участка мы ремонтируем точечно — без переделки всей работы.",
          },
        ],
      },
      finalCta: {
        title: "Не ждите — чем раньше вы приедете, тем больше шансов у зуба",
        body: "Позвоните сейчас по номеру 603 31 96 48 или отправьте фото в WhatsApp. Мы перезвоним в течение 30 минут и скажем, что именно делать.",
      },
    },

    toothache: {
      breadcrumb: "Острая зубная боль",
      h1: "Острая зубная боль на Майорке? Мы принимаем вашу боль всерьёз — срочный приём в Пальме",
      heroIntro: "Зубная боль выматывает: мешает есть, работать и спать. Не терпите — боль означает, что зубу нужна помощь, и в большинстве случаев мы снимаем её в день обращения. Позвоните: мы перезвоним в течение 30 минут, приём и консультация на немецком, английском и испанском языках.",
      heroNote: "Напишите нам в WhatsApp — опишите, где и как болит, и мы скажем, насколько это срочно.",
      sections: [
        {
          icon: "warning",
          title: "Когда зубная боль — экстренный случай?",
          intro: "Позвоните нам сразу, если вы замечаете хотя бы один из этих «красных флагов»:",
          items: [
            {
              title: "Пульсирующая боль в ритме сердца",
              body: "Обычно признак воспаления зубного нерва (пульпита). Само по себе оно не проходит — без лечения нерв погибает, и инфекция уходит к корню.",
            },
            {
              title: "Боль будит или не даёт уснуть",
              body: "Боль, из-за которой вы просыпаетесь, — почти всегда признак активного воспаления. Это повод для срочного приёма, а не для ожидания.",
            },
            {
              title: "Отёк или температура",
              body: "Опухшая щека или десна вместе с температурой указывают на флюс (абсцесс зуба) — действовать нужно в тот же день. Об этом у нас есть отдельная страница.",
            },
            {
              title: "Резкая боль при накусывании, на холодное или горячее",
              body: "Возможна трещина зуба, глубокий кариес или воспаление у корня. Точный ответ даёт осмотр и цифровой рентген.",
            },
          ],
        },
        {
          icon: "bedtime",
          title: "Зубная боль ночью: почему усиливается и как продержаться до приёма",
          intro: "В положении лёжа приток крови к голове увеличивается, давление в воспалённом зубе растёт — поэтому ночью боль сильнее, а отвлечься не на что. Вот что честно помогает продержаться до приёма:",
          items: [
            {
              title: "Спите с приподнятой головой",
              body: "Вторая подушка уменьшает приток крови к области воспаления — часто боль становится терпимее уже от этого.",
            },
            {
              title: "Охлаждайте снаружи",
              body: "Холодный компресс через ткань на щёку, по 10–15 минут с перерывами. Тепло, наоборот, усиливает воспаление — грелки и горячие полоскания под запретом.",
            },
            {
              title: "Обезболивающие — только как честный «мост» до приёма",
              body: "Безрецептурные обезболивающие могут кратковременно облегчить состояние — соблюдайте инструкцию по применению или посоветуйтесь в аптеке и обязательно скажите нам перед лечением, какие препараты вы принимали. Важно: средства с ацетилсалициловой кислотой могут усиливать кровоточивость.",
            },
          ],
        },
        {
          icon: "search",
          title: "Частые причины острой зубной боли",
          intro: "За сильной болью почти всегда стоит конкретная причина, которую можно найти и устранить:",
          items: [
            {
              title: "Пульпит — воспаление зубного нерва",
              body: "Самая частая причина невыносимой боли. Воспалённый нерв в замкнутой полости зуба не может «перетерпеться» — ему нужно лечение.",
            },
            {
              title: "Глубокий кариес",
              body: "Пока кариес в эмали, зуб молчит. Боль от холодного, сладкого или горячего означает, что процесс подобрался к нерву — но зуб ещё можно спасти малыми средствами.",
            },
            {
              title: "Трещина зуба",
              body: "Часто не видна глазу и проявляется болью при накусывании. Мы находим трещины с помощью дентального микроскопа и цифрового рентгена.",
            },
            {
              title: "Флюс (абсцесс зуба)",
              body: "Гнойное воспаление с отёком и температурой — отдельный экстренный случай, требующий действий в тот же день.",
            },
          ],
        },
      ],
      solve: {
        title: "Как мы решаем это в SeaDent: остановить боль и сохранить зуб",
        intro: "Наша цель — не заглушить боль, а устранить её причину. Ваш зуб для нас — не повод для щипцов: сначала мы всегда стараемся сохранить.",
        points: [
          {
            title: "Точный диагноз с цифровым 3D-рентгеном",
            body: "Цифровая рентгенодиагностика показывает воспаление у корня и скрытые трещины — быстро, с минимальной лучевой нагрузкой и результатом сразу на экране.",
          },
          {
            title: "Экстренное лечение каналов под дентальным микроскопом",
            body: "Под микроскопом мы видим и обрабатываем все каналы, включая самые тонкие, — это заметно повышает шансы сохранить зуб. Боль, как правило, уходит уже после первого визита.",
          },
          {
            title: "Дентальный лазер для стерилизации каналов",
            body: "Лазер уничтожает бактерии в корневых каналах и поддерживает заживление — бережно и без лишнего дискомфорта.",
          },
        ],
        links: [
          { text: "Наши технологии: микроскоп, лазер и 3D-рентген", routeKey: "technologies" },
          { text: "Флюс или опухла щека — когда действовать немедленно", routeKey: "emergency-abscess" },
        ],
      },
      faq: {
        title: "Частые вопросы: острая зубная боль",
        items: [
          {
            q: "Вы примете меня сегодня?",
            a: "При острой боли мы делаем всё, чтобы принять вас в день обращения. Позвоните по номеру 603 31 96 48 — мы перезвоним в течение 30 минут и назовём время приёма.",
          },
          {
            q: "Сколько стоит лечение?",
            a: "Зависит от причины боли: осмотр с рентгеном, пломба или лечение каналов — разный объём работы. Перед началом лечения вы получаете письменную смету, оплатить можно картой.",
          },
          {
            q: "Помогают ли домашние средства?",
            a: "Холод и полоскания могут ненадолго облегчить состояние — но причину они не устраняют. Если боль вызвана воспалением нерва, она вернётся, и обычно сильнее. Честный ответ: домашние средства — это «мост» до приёма, а не лечение.",
          },
          {
            q: "А если боль началась в выходные?",
            a: "Звоните: телефон неотложной помощи отвечает круглосуточно и без выходных. Приём в субботу или воскресенье организуется по телефонной договорённости — подробности в разделе о доступности на странице неотложной помощи.",
          },
        ],
      },
      finalCta: {
        title: "Зубная боль не пройдёт от ожидания — но мы можем её остановить",
        body: "Позвоните сейчас: 603 31 96 48. Мы перезвоним в течение 30 минут, найдём причину боли и в большинстве случаев снимем её в тот же день.",
      },
    },

    tourists: {
      breadcrumb: "Туристам",
      h1: "Зубная боль в отпуске на Майорке — пошаговый план действий",
      heroIntro: "Зубная боль умеет выбирать самый неподходящий момент — например, отпуск. Спокойно: вы не останетесь без помощи. Мы принимаем туристов без направления и без долгой записи, приём и консультация — на немецком, английском и испанском языках.",
      heroNote: "Быстрее всего — WhatsApp: опишите проблему или отправьте фото, и мы ответим, что делать и насколько это срочно.",
      sections: [
        {
          icon: "format_list_numbered",
          title: "4 самые частые зубные проблемы в отпуске",
          intro: "Коротко — что делать в первый момент. Подробные инструкции вы найдёте на страницах по каждой теме.",
          items: [
            {
              title: "Острая зубная боль",
              body: "Не откладывайте до возвращения домой: воспаление за несколько дней может превратиться во флюс. Охладите щёку снаружи и позвоните нам — часто мы снимаем боль в день обращения.",
            },
            {
              title: "Сломался зуб",
              body: "Сохраните осколок в молоке или слюне и не трогайте место скола. В большинстве случаев мы восстанавливаем зуб композитом за один визит — и отпуск продолжается.",
            },
            {
              title: "Выпала пломба или коронка",
              body: "Не приклеивайте коронку самостоятельно и не жуйте на этой стороне. Зуб без защиты чувствителен к температуре и бактериям — покажитесь нам в ближайшие день-два.",
            },
            {
              title: "Флюс или опухла щека",
              body: "Самый серьёзный сценарий: флюс не проходит сам, действовать нужно сегодня. Охлаждайте, ни в коем случае не грейте — и звоните немедленно.",
            },
          ],
        },
        {
          icon: "payments",
          title: "Расходы, оплата и документы — без сюрпризов",
          intro: "Никто не хочет в отпуске неожиданных счетов. Поэтому у нас всё прозрачно с первой минуты:",
          items: [
            {
              title: "Письменная смета до начала лечения",
              body: "Сначала осмотр и диагноз, затем — понятная смета в письменном виде. Вы заранее знаете, какие процедуры планируются и сколько они стоят, и только после вашего согласия мы начинаем лечение.",
            },
            {
              title: "Оплата картой",
              body: "Мы принимаем банковские карты — искать банкомат с наличными в чужом городе не придётся.",
            },
            {
              title: "Документы для международной страховой",
              body: "Вы получаете подробный счёт с диагнозом и перечнем процедур, а по запросу — заключение врача и рентгеновские снимки. Как правило, этого пакета достаточно для подачи заявления на возмещение в международную страховую компанию. Условия выплат зависят от вашего полиса — при возможности уточните их до начала лечения.",
            },
            {
              title: "Без направления",
              body: "Направление от терапевта или местная страховка не нужны: просто позвоните или напишите нам — и приходите.",
            },
          ],
        },
        {
          icon: "directions",
          title: "Как добраться до клиники из отеля",
          intro: "Мы находимся в самом центре Пальмы: Avenida de Jaime III, 3 — одна из главных улиц города, её знает любой таксист. Ориентир — универмаг El Corte Inglés.",
          items: [
            {
              title: "Из Плайя-де-Пальма и Ареналя",
              body: "Такси до центра Пальмы — обычно 15–25 минут. Регулярные городские автобусы идут в центр; от остановки в районе Avenida de Jaime III до клиники — пара минут пешком.",
            },
            {
              title: "Из Алькудии и с севера или востока острова",
              body: "На машине или междугороднем автобусе до Пальмы — как правило, около часа. Ближайшие парковки — Vía Roma и El Corte Inglés, в двух минутах ходьбы от клиники.",
            },
            {
              title: "Из Порт-д'Андрача, Санта-Понсы и с юго-запада",
              body: "По трассе в сторону Пальмы — обычно 25–40 минут на машине или такси. Позвоните заранее — мы согласуем время так, чтобы вы не ждали.",
            },
          ],
        },
        {
          icon: "settings_suggest",
          title: "Проблемы с имплантатом в отпуске — даже если его ставили не у нас",
          intro: "Разболелся имплантат, воспалилась десна вокруг него или расшаталась коронка? Мы принимаем пациентов с имплантатами, установленными в других клиниках и странах — например, в Турции или Венгрии. Цифровой 3D-рентген и компьютерная диагностика быстро показывают, что происходит: расшатавшуюся коронку часто можно зафиксировать заново, а воспаление — взять под контроль ещё до вашего вылета.",
        },
      ],
      solve: {
        title: "Как мы решаем это в SeaDent: чтобы отпуск продолжился",
        intro: "Мы лечим так, чтобы вы вернулись на пляж, а не в зал ожидания:",
        points: [
          {
            title: "По возможности — окончательное лечение за один визит",
            body: "Сломанный зуб мы чаще всего восстанавливаем прямой композитной реставрацией за одно посещение — без временных конструкций и повторных визитов. При острой боли — диагностика и лечение в день обращения.",
          },
          {
            title: "Отчёт и снимки для вашего стоматолога дома",
            body: "По окончании лечения вы получаете заключение врача и рентгеновские снимки, чтобы ваш стоматолог дома мог спокойно продолжить лечение с того места, где остановились мы.",
          },
          {
            title: "Понятное общение на каждом шаге",
            body: "Приём и оформление документов — на немецком, английском и испанском языках. Опишите жалобы в WhatsApp или приложите фото — так наша команда поймёт ситуацию заранее.",
          },
        ],
        links: [
          { text: "Композитная реставрация за один визит", routeKey: "composite" },
          { text: "Имплантаты: диагностика и помощь при осложнениях", routeKey: "implants" },
        ],
      },
      faq: {
        title: "Частые вопросы туристов",
        items: [
          {
            q: "Можно ли оплатить картой?",
            a: "Да, мы принимаем банковские карты. Перед лечением вы получаете письменную смету, после — подробный счёт.",
          },
          {
            q: "Смогу ли я лететь после лечения?",
            a: "В большинстве случаев — да, часто уже в тот же день. После отдельных вмешательств врач даст индивидуальную рекомендацию. Скажите нам дату вылета — мы учтём её в плане лечения.",
          },
          {
            q: "Вы дадите документы для моей страховой?",
            a: "Да: подробный счёт с диагнозом и перечнем процедур, а по запросу — заключение врача и снимки. Этого обычно достаточно для заявления на возмещение в международную страховую компанию.",
          },
          {
            q: "Примете ли вы меня в день вылета?",
            a: "Позвоните как можно раньше — мы постараемся найти время и честно скажем, что успеем сделать до рейса, а что лучше доделать дома у вашего стоматолога.",
          },
          {
            q: "Нужно ли направление или местная страховка?",
            a: "Нет. Мы принимаем туристов напрямую — достаточно позвонить по номеру 603 31 96 48 или написать в WhatsApp.",
          },
          {
            q: "Говорите ли вы по-русски?",
            a: "Нет, приём и консультация проходят на немецком, английском и испанском языках. Опишите жалобы в WhatsApp или приложите фото — так мы поймём ситуацию заранее.",
          },
        ],
      },
      finalCta: {
        title: "Не дайте зубу испортить отпуск — мы поможем сегодня",
        body: "Позвоните по номеру 603 31 96 48 или напишите в WhatsApp. Мы перезвоним в течение 30 минут — клиника в самом центре Пальмы, Avenida de Jaime III, 3.",
      },
    },

    abscess: {
      breadcrumb: "Флюс",
      h1: "Флюс или опухла щека? Действуйте сегодня — мы на связи",
      heroIntro: "Опухла щека, десна вздулась, зуб реагирует на малейшее прикосновение? Скорее всего, это флюс — гнойное воспаление, которое врачи называют абсцессом зуба. Ситуация серьёзная, но решаемая: позвоните нам сегодня, мы перезвоним в течение 30 минут и скажем, что делать.",
      heroNote: "Приём и консультация — на немецком, английском и испанском языках.",
      warnbox: {
        title: "Когда сначала — скорая помощь",
        body: "При температуре, затруднённом глотании, одышке или отёке, распространяющемся к глазу или шее: немедленно звоните в службу спасения 112 (на Балеарских островах — 061) — и только затем нам.",
      },
      sections: [
        {
          icon: "visibility",
          title: "Как распознать флюс: симптомы",
          intro: "Флюс — народное название гнойного воспаления у корня зуба или в десне. Вот как отличить его от безобидного раздражения:",
          items: [
            {
              title: "Абсцесс зуба (у корня)",
              body: "Постоянная пульсирующая боль; ощущение, что зуб «вырос» и первым смыкается с другими; боль при накусывании; отёк десны или щеки. Причина — инфекция погибшего нерва, ушедшая к корню зуба.",
            },
            {
              title: "Абсцесс десны",
              body: "Ограниченная болезненная «шишка» на десне, часто с белой гнойной точкой. Возникает из-за глубокого десневого кармана или застрявшего инородного тела — например, рыбьей косточки.",
            },
            {
              title: "Безобидное раздражение",
              body: "Лёгкое покраснение или точечная кровоточивость при чистке — без отёка, боли и температуры. Это не экстренный случай, но повод показаться врачу на этой неделе. Сомневаетесь, что именно у вас? Отправьте нам фото в WhatsApp — мы поможем оценить ситуацию ещё до приёма.",
            },
          ],
        },
        {
          icon: "hourglass_bottom",
          title: "Почему ждать опасно: флюс не проходит сам",
          intro: "Иногда гнойник прорывается, боль стихает — и кажется, что всё позади. Это обманчивое облегчение: источник инфекции остаётся на месте, и воспаление возвращается, как правило, сильнее. Без лечения инфекция может распространяться на челюстную кость и соседние ткани, а в редких случаях — по всему организму; именно поэтому отёк с температурой требует действий в тот же день. И честная сторона вопроса: чем раньше начато лечение, тем оно проще, бережнее и дешевле. С флюсом к врачу нужно сегодня — не «когда-нибудь потом».",
        },
        {
          icon: "recommend",
          title: "Что делать до приёма",
          intro: "Пока вы добираетесь к нам, соблюдайте четыре простых правила:",
          items: [
            {
              title: "Охлаждайте",
              body: "Холодный компресс через ткань снаружи щеки, по 10–15 минут с перерывами — уменьшает отёк и боль.",
            },
            {
              title: "Ни в коем случае не грейте",
              body: "Грелки, тёплые компрессы, горячие полоскания и сауна усиливают воспаление и помогают гною распространяться в глубину. Тепло при флюсе — самая опасная «народная» ошибка.",
            },
            {
              title: "Не вскрывайте гнойник самостоятельно",
              body: "Прокол иглой или выдавливание загоняет инфекцию глубже и грозит серьёзными осложнениями. Вскрытие и дренаж — задача врача в стерильных условиях.",
            },
            {
              title: "Ешьте и пейте аккуратно",
              body: "Мягкая еда нейтральной температуры. Безрецептурные обезболивающие могут кратковременно облегчить состояние — соблюдайте инструкцию и обязательно скажите нам перед лечением, что вы принимали.",
            },
          ],
        },
      ],
      solve: {
        title: "Как мы лечим флюс в SeaDent",
        intro: "Наша задача — быстро убрать боль и устранить сам источник инфекции, а не только симптомы:",
        points: [
          {
            title: "Дренаж и немедленное облегчение",
            body: "Мы бережно вскрываем и дренируем гнойный очаг — давление уходит, и боль спадает почти сразу. Дентальный лазер помогает остановить кровотечение и уменьшить количество бактерий.",
          },
          {
            title: "Лечение причины под дентальным микроскопом",
            body: "Чаще всего источник абсцесса — инфицированный корневой канал. Мы обрабатываем его под микроскопом и стерилизуем лазером — так зуб в большинстве случаев удаётся сохранить.",
          },
          {
            title: "Антибиотики — только по назначению врача",
            body: "Антибиотик сам по себе флюс не вылечит: без устранения источника воспаление вернётся. Нужны ли антибиотики именно вам, врач решает после осмотра — индивидуально и обоснованно.",
          },
        ],
        links: [
          { text: "Наши технологии: микроскоп, лазер и 3D-рентген", routeKey: "technologies" },
          { text: "Острая зубная боль — что делать до приёма", routeKey: "emergency-toothache" },
        ],
      },
      faq: {
        title: "Частые вопросы: флюс",
        items: [
          {
            q: "Проходит ли флюс сам по себе?",
            a: "Нет. Даже если гнойник прорвался и боль стихла, источник инфекции остаётся — воспаление вернётся и может распространиться на кость и соседние ткани. Абсцесс зуба всегда требует лечения у врача.",
          },
          {
            q: "Можно ли получить антибиотики без приёма?",
            a: "Нет — и это в ваших интересах. Без осмотра невозможно найти источник инфекции, а антибиотик без устранения причины лишь откладывает проблему. После осмотра врач при необходимости назначит подходящий препарат.",
          },
          {
            q: "Сколько стоит лечение флюса?",
            a: "Зависит от объёма: дренаж, лечение каналов или комбинация процедур. Перед началом лечения вы получаете письменную смету, оплатить можно картой.",
          },
          {
            q: "Можно ли лететь с флюсом?",
            a: "Не стоит без осмотра: перепады давления в полёте могут резко усилить боль, а активная инфекция — это риск. Покажитесь нам до вылета — часто мы успеваем снять острое состояние, чтобы перелёт прошёл спокойно.",
          },
        ],
      },
      finalCta: {
        title: "Опухла щека? Не ждите до завтра",
        body: "Флюс не проходит сам — но хорошо поддаётся лечению, если действовать сегодня. Позвоните: 603 31 96 48 — мы перезвоним в течение 30 минут.",
      },
    },
  },

  // Treatments Section
  treatments: {
    title: "Процедуры: Ваша улыбка в лучших руках",
    intro: "Наши процедуры в SeaDent Mallorca охватывают весь спектр современной стоматологии — от профилактики до эстетического совершенства. Благодаря передовым технологиям и чуткому уходу мы обеспечиваем здоровье вашей ротовой полости и сияющую улыбку.",
    cta: "Записаться на прием",
    categories: [
      {
        title: "Профилактика и гигиена",
        description: "Регулярные осмотры и профилактические меры для здоровья полости рта в долгосрочной перспективе. Мы делаем ставку на индивидуальные консультации и современную диагностику.",
        treatments: [
          {
            title: "Осмотр и консультация",
            description: "Подробное обследование и персональные рекомендации для здоровья ваших зубов."
          },
          {
            title: "Профессиональная чистка зубов",
            description: "Тщательное удаление зубного налета для ощущения чистоты и свежести."
          },
          {
            title: "Пломбы",
            description: "Высококачественные пломбы, которые восстанавливают эстетику и функциональность ваших зубов."
          },
          {
            title: "Детская профилактика",
            description: "Профилактика, адаптированная для детей, чтобы защитить зубы ваших малышей в игровой форме."
          }
        ]
      },
      {
        title: "Терапия боли",
        description: "Безболезненное лечение с использованием щадящих техник и новейших технологий. Ваше благополучие находится в центре каждого сеанса.",
        treatments: [
          {
            title: "Лечение боли",
            description: "Быстрое и эффективное облегчение зубной боли, подобранное индивидуально для вас."
          },
          {
            title: "Удаление зуба",
            description: "Бережное удаление зубов, когда другое решение невозможно."
          },
          {
            title: "Лечение корневых каналов",
            description: "Точная эндодонтия для спасения воспаленных зубов и облегчения боли."
          },
          {
            title: "Проблемы с челюстью",
            description: "Целевая терапия проблем височно-нижнечелюстного сустава (ВНЧС) для улучшения качества жизни."
          }
        ]
      },
      {
        title: "Пародонтит",
        description: "Профессиональное лечение заболеваний десен для стабильного здоровья полости рта. Своевременные меры предотвращают долгосрочный ущерб.",
        treatments: [
          {
            title: "Методы лечения",
            description: "Профессиональная чистка и терапия для эффективной борьбы с воспалением десен."
          }
        ]
      },
      {
        title: "Для идеальной улыбки (Эстетика)",
        description: "Эстетические решения для уверенной улыбки в полном соответствии с вашими пожеланиями. Наши методы бережны и эффективны.",
        treatments: [
          {
            title: "Композитная реставрация",
            description: "Прямая эстетическая реставрация за один визит – без обточки, с послойной техникой от руки."
          },
          {
            title: "Invisalign",
            description: "Прозрачные элайнеры для незаметной и комфортной коррекции зубов."
          },
          {
            title: "Отбеливание зубов",
            description: "Бережное отбеливание зубов для белоснежной и сияющей улыбки."
          },
          {
            title: "Каппы от бруксизма",
            description: "Индивидуальные каппы для предотвращения скрежета зубами и защиты вашего прикуса."
          },
          {
            title: "Виниры",
            description: "Ультратонкие керамические накладки для идеального и естественного вида ваших зубов."
          },
          {
            title: "Коронки и мосты",
            description: "Высококачественное протезирование для восстановления функции и эстетики поврежденных зубов."
          }
        ]
      },
      {
        title: "Имплантация",
        description: "Самые современные технологии имплантации для естественного и долговечного протезирования. Наши имплантаты обеспечивают вам комфорт и безопасность.",
        treatments: [
          {
            title: "Одиночные имплантаты",
            description: "Замена отдельных зубов высококачественными имплантатами для естественного ощущения."
          },
          {
            title: "Множественная имплантация",
            description: "Комплексные решения по имплантации при больших промежутках между зубами или полном отсутствии зубов."
          },
          {
            title: "Имплантация с немедленной нагрузкой",
            description: "Имплантаты с немедленной нагрузкой для быстрого восстановления жевательной функции."
          }
        ]
      }
    ]
  },

  // Benefits Section
  benefits: {
    title: "Ваши преимущества: Превосходство, комфорт и сияющая улыбка.",
    items: [
      {
        title: "Опыт и компетентность",
        description: "Квалифицированные стоматологи, постоянно повышающие свою квалификацию."
      },
      {
        title: "Современные технологии",
        description: "Точное лечение с помощью цифрового рентгена и инновационного оборудования."
      },
      {
        title: "Ориентированный на пациента подход",
        description: "Чуткое отношение, какое вы ожидаете от друга."
      },
      {
        title: "Средиземноморская атмосфера",
        description: "Расслабляющая обстановка, вдохновленная красотой Майорки."
      },
      {
        title: "Многоязычный сервис",
        description: "Лечение на немецком, английском и испанском языках."
      },
      {
        title: "Центральное расположение",
        description: "Легкий доступ в самом центре Пальма-де-Майорка."
      }
    ]
  },

  // Approach Section
  approach: {
    title: "Новый взгляд на стоматологию: Ваше благополучие — наше обещание.",
    text: "В SeaDent мы хотим, чтобы ваш визит к стоматологу стал особенным. Наша миссия — предложить вам не только превосходное медицинское лечение, но и атмосферу, в которой вы будете чувствовать себя расслабленно и услышанно. Для нас это означает:",
    points: [
      "Мы слушаем: ваши желания и потребности находятся в центре нашего внимания. Мы уделяем время индивидуальной консультации.",
      "Расслабление и безболезненное лечение: благодаря новейшим методам и вниманию к вашему самочувствию мы делаем процедуры максимально комфортными.",
      "Прозрачность создает доверие: мы четко и понятно объясняем каждый этап лечения, чтобы вы чувствовали себя в безопасности."
    ]
  },

  // Experience Section
  experience: {
    title: "Ваши моменты благополучия в SeaDent Майорка.",
    text: "В SeaDent речь идет о большем, чем просто стоматология — мы хотим, чтобы ваш визит превратился в момент релаксации. Наша клиника сочетает новейшие методы лечения с атмосферой, вдохновленной спокойствием и красотой Майорки.",
    points: [
      "Уютная атмосфера со средиземноморскими цветами и естественным светом.",
      "Дружелюбная и чуткая команда, которая тепло приветствует вас.",
      "Короткое время ожидания благодаря эффективной организации работы клиники.",
      "Комфортные зоны ожидания с Wi-Fi, напитками и растениями.",
      "Успокаивающие детали, такие как расслабляющая музыка во время лечения."
    ]
  },

  // Social Proof Section
  socialProof: {
    title: "Что говорят наши пациенты",
    reviews: [
      {
        text: "Профессионально на высшем уровне, по-человечески замечательно, здесь действительно чувствуешь себя в надежных руках ❤️. Огромное спасибо стоматологу и всей команде. Именно так я представляю себе современную, радушную клинику 🦷🤗.",
        author: "Марсель"
      },
      {
        text: "Я еще никогда не встречала такого преданного своему делу, душевного и честного стоматолога. Он всегда уделяет много времени — даже в нерабочее время — и всегда готов помочь своим пациентам. Лечение проходит профессионально и с большим сочувствием. Даже после приема он заботится о последующем уходе и хочет знать, как дела — это далеко не само собой разумеющееся. Абсолютно замечательный стоматолог, которому можно полностью доверять. Искренняя рекомендация!",
        author: "Стефани"
      },
      {
        text: "Лучший стоматолог!!! Конечно же, именно в отпуске у меня разболелся зуб после пломбы, которую поставили пару недель назад. Ждать, пока я вернусь домой в Германию к своему стоматологу, было невозможно. Я сразу получила запись к Яну Д. Хайрингхоффу. Он очень приятный человек, выслушивает, задает вопросы и прекрасно провел необходимое лечение корневого канала. Мой стоматолог в Германии позже сказала, что он проделал отличную работу. Во время и после лечения у меня не было никаких проблем или даже болей. Могу смело его рекомендовать!",
        author: "Хендрик"
      },
      {
        text: "Я была очень рада получить быстрый и простой ответ после бессонной ночи из-за острой зубной боли. Лечение также последовало незамедлительно и профессионально. Приятно, что еще есть врачи, которые работают и по субботам, и при этом остаются очень дружелюбными и компетентными. Большое спасибо.",
        author: "Т."
      },
      {
        text: "Немедленное (!) и профессиональное экстренное лечение. Прозрачно и на равных. Большое спасибо команде, я чувствовала себя в надежных руках. ДОПОЛНЕНИЕ (спустя несколько месяцев): Вернулась в клинику и на этот раз воспользовалась услугой отбеливания. Все профессионально и дружелюбно. Просто рекомендуемая клиника! 👍",
        author: "Хуберт"
      },
      {
        text: "Меня встретили и пролечили очень дружелюбно. Доктор Хайрингхофф уделил много времени и все подробно объяснил. По моей просьбе он сделал 2 рентгеновских снимка моей новой коронки. Я боялась, что у меня воспаление корня. Это было не так, и я смогла уйти со спокойной душой. Безусловно рекомендую доктора Хайрингхоффа. Спасибо за скорую помощь в воскресенье ☺️.",
        author: "Эльке"
      },
      {
        text: "Честно говоря, мои зубы раньше выглядели просто ужасно — так что на фотографиях я предпочитал серьезный вид улыбке. Но тут появился Ян! Этот парень превратил мой рот в улыбку, на которую любо-дорого посмотреть. Все очень спокойно, никакого страха перед стоматологом и внимание к деталям. Теперь я снова улыбаюсь, как в рекламе зубной пасты. Спасибо, Ян — ты мой зубной герой!",
        author: "Патрик"
      },
      {
        text: "Большое спасибо за скорую помощь. В отпуске случилась экстренная ситуация с зубом. Сразу получил запись, где меня отлично проконсультировали и пролечили. Рекомендую от всего сердца.",
        author: "Симоне"
      }
    ]
  },

  // CTA Section
  cta: {
    title: "Почувствуйте стоматологию, где вы на первом месте.",
    text: "Готовы к стоматологической практике, сочетающей профессионализм с средиземноморским комфортом? Запишитесь на прием в SeaDent Mallorca и откройте для себя новый вид стоматологии – мы будем рады приветствовать вас в Пальме!",
    bookButton: "Записаться на прием онлайн",
    callButton: "Позвоните нам",
    visitInfo: "Посетите нас: Avenida de Jaime III № 3, Palma, Mallorca."
  },

  // Services (Home page cards)
  services: {
    title: "Наши услуги",
    subtitle: "Комплексная стоматология",
    implants: {
      title: "Зубные имплантаты",
      description: "Долговечное решение при потере зубов с использованием титановых имплантатов"
    },
    veneers: {
      title: "Виниры",
      description: "Преобразите свою улыбку с помощью индивидуальных фарфоровых виниров"
    },
    cleaning: {
      title: "Профессиональная чистка",
      description: "Тщательная чистка и профилактика для оптимального здоровья полости рта"
    },
    crown: {
      title: "Коронки и мосты",
      description: "Восстановление поврежденных зубов высококачественными коронками и мостами"
    },
    orthodontics: {
      title: "Ортодонтия",
      description: "Выровняйте зубы с помощью современных ортодонтических методов"
    },
    surgery: {
      title: "Челюстно-лицевая хирургия",
      description: "Экспертные хирургические вмешательства в наших современных операционных"
    }
  },

  // Technologies Section
  technologies: {
    title: "Современные технологии",
    subtitle: "Оборудование последнего поколения",
    intro: "В SeaDent мы ставим в приоритет индивидуальную, приятную и безболезненную стоматологию благодаря использованию передовых технологий.",
    sections: [
      {
        title: "Цифровая стоматология",
        description: "Цифровые оттиски и 3D-визуализация для точной диагностики и планирования лечения.",
        benefits: [
          "Быстрая и удобная цифровая фиксация зубов.",
          "Значительно более высокий комфорт по сравнению со слепками.",
          "Возможность визуализировать результаты лечения.",
          "Способствует более быстрому и приятному лечению."
        ]
      },
      {
        title: "Дентальный лазер: Исцеляющий свет",
        description: "Дентальный лазер — это универсальный инструмент, который заменяет многие традиционные инструменты и способствует заживлению. Он работает точно, эффективно и безопасно. Преимущества лазера для вас:",
        benefits: [
          "Поддерживает заживление десен, костей и многого другого.",
          "Позволяет проводить небольшие хирургические вмешательства.",
          "Помогает в стерилизации корневых каналов.",
          "Используется для остановки кровотечения во время процедур.",
          "Эффективное лечение афт и герпеса.",
          "Поддерживает лечение пародонтита.",
          "Помогает в десенсибилизации чувствительных шеек зубов."
        ]
      },
      {
        title: "Технологии имплантации",
        description: "Передовые системы имплантации для оптимальной интеграции и долгосрочного успеха.",
        benefits: [
          "Высококачественные биосовместимые материалы",
          "Компьютерное планирование для максимальной безопасности",
          "Долговечные и естественно выглядящие результаты"
        ]
      },
      {
        title: "Стоматологический микроскоп",
        description: "Микроскопическая точность для эндодонтического лечения и тонких хирургических процедур.",
        benefits: [
          "Максимальная точность в деталях",
          "Более высокие показатели успеха при лечении корневых каналов",
          "Сохранение как можно большего количества естественной структуры зуба"
        ]
      }
    ],
    conclusion: "Сочетая эти современные технологии с нашим вниманием к доверию и прозрачности, вы испытаете в SeaDent профессиональную, приятную и персональную стоматологию."
  },


  // Other sections
  implants: {
    title: "Имплантаты – Для лучшего качества жизни",
    intro: "Зубные имплантаты — это самый современный и естественный способ замены отсутствующих зубов. Они обеспечивают не только идеальную эстетику, но и возвращают вам ощущение и уверенность в собственных зубах. В нашей клинике в Пальме мы придерживаемся самых высоких стандартов качества и используем самые современные методы.",
    benefitsTitle: "Преимущества имплантатов",
    benefit1: "Естественный вид и ощущения, сравнимые с собственными зубами",
    benefit2: "Улучшение жевательной функции и способности говорить",
    benefit3: "Долговечное решение с высоким процентом успеха",
    benefit4: "Сохранение структуры костной ткани челюсти",
    qualityTitle: "Высочайшее качество и точность",
    quality: "Мы используем только высококачественные материалы и самые современные методы цифрового планирования. Это гарантирует вам точный и долговечный результат, который идеально вам подходит.",
    experienceTitle: "Приятный опыт лечения",
    experience: "Благодаря малоинвазивным техникам и мягкой анестезии лечение у нас проходит особенно бережно. Наша цель — чтобы вы чувствовали себя комфортно и в безопасности на протяжении всего процесса.",
    processTitle: "Путь к вашим новым имплантатам",
    step1Title: "Консультация",
    step1: "Подробная беседа и индивидуальное планирование",
    step2Title: "Имплантация",
    step2: "Бережная процедура под местной анестезией",
    step3Title: "Заживление",
    step3: "Интеграция имплантата с костью челюсти",
    step4Title: "Зубной протез",
    step4: "Изготовление и установка индивидуального зубного протеза",
    foreignImplants: {
      title: "Проблемы с имплантатами — поможем, даже если их ставили в другой клинике",
      intro: "Болит имплантат, расшаталась коронка или воспалилась десна вокруг него? Мы примем вас, даже если имплантат был установлен в другой клинике или в другой стране.",
      body: "С помощью цифрового 3D-рентгена и компьютерного планирования мы точно оцениваем состояние вашего имплантата: заново фиксируем расшатавшиеся коронки, лечим воспаление окружающих тканей (периимплантит) и честно говорим, какие у вас есть варианты. Особенно если проблема застала вас на Майорке во время отпуска — не ждите возвращения домой: воспаление вокруг имплантата со временем только усиливается.",
      linkText: "Зубная боль в отпуске на Майорке — пошаговый план действий",
    },
  },
  veneers: {
    title: "Виниры – Для вашей сияющей улыбки",
    intro: "Ультратонкие керамические накладки, известные как виниры, предлагают элегантное решение для постоянной коррекции незначительных эстетических несовершенств передних зубов. Будь то изменение цвета, небольшие промежутки или легкая кривизна — мы поможем вам достичь гармоничной и естественной улыбки.",
    imageAlt: "Лечение винирами в SeaDent Mallorca",
    description: "Виниры — это индивидуально изготовленные накладки, которые надежно прикрепляются к поверхности зуба. Они характеризуются высокой биосовместимостью и эстетикой, которую трудно отличить от натуральных зубов. Всего за несколько сеансов мы преобразим вашу улыбку и подарим вам новую уверенность в себе."
  },
  composite: {
    title: "Прямая композитная реставрация – Ваша новая улыбка за один визит",
    intro: "Прямое аддитивное восстановление Ваших зубов высококачественным композитом цвета зуба в послойной технике от руки – без обточки, без лаборатории, с видимым результатом в тот же день.",
    heroAlt: "Сравнение «до/после» композитной реставрации в SeaDent Mallorca",
    heroCaption: "Сравнение «до» и «после» в одном кадре. Реставрация композитом на верхних передних зубах справа — рядом с нетронутой стороной слева. Форму, длину, цвет и яркость мы подбираем индивидуально под Ваши пожелания.",
    whatIsTitle: "Что такое прямая композитная реставрация?",
    whatIsBody: "Прямая композитная реставрация — это современный, минимально инвазивный метод эстетической стоматологии. Мы заново формируем форму, длину, цвет и положение Ваших зубов без обточки, без слепков для лаборатории и без временных конструкций. Высококачественный композитный материал цвета зуба наносится непосредственно на зуб тонкими слоями, моделируется вручную и полимеризуется световой лампой.",
    whatIsResult: "Результат Вы видите в тот же день.",
    distinctionTitle: "Важно: это не виниры",
    distinctionBody: "При установке классических керамических виниров приходится обтачивать здоровую ткань зуба, чтобы разместить накладку. Наш метод полностью аддитивный: мы добавляем материал, не уменьшая натуральный зуб – и результат полностью обратим.",
    indicationsTitle: "Для кого подходит?",
    indications: [
      { title: "Эстетическая коррекция передних зубов", body: "Сколы, неровные края, асимметрия и нарушения формы видимых зубов." },
      { title: "Закрытие диастем", body: "Даже промежутки до 6–7 мм можно закрыть без ортодонтии." },
      { title: "Восстановление стёртых зубов", body: "При бруксизме, эрозии или возрастном истирании мы восстанавливаем исходную форму и длину зубов." },
      { title: "Аддитивное обновление улыбки", body: "Гармоничное преобразование нескольких передних зубов за один приём." }
    ],
    whyTitle: "В чём особенность нашего метода",
    whyBuildupAlt: "Фотореалистичный макроснимок послойной техники композита со световой полимеризацией",
    why: [
      { title: "Результат за один визит", body: "30–60 минут на один зуб. Полное обновление переднего ряда (6–8 зубов) выполняется за один приём. Без лаборатории, без второго визита, без временных коронок." },
      { title: "Послойная техника от руки", body: "Дентинные и эмалевые массы наносятся в несколько слоёв и моделируются вручную – как у натурального зуба. Результат имеет настоящую глубину, опалесценцию и преломление света." },
      { title: "Бережно и обратимо", body: "Твёрдые ткани Вашего зуба сохраняются полностью. Все будущие варианты лечения остаются открытыми." }
    ],
    processTitle: "Этапы лечения",
    processIllustrationAlt: "Схема послойного нанесения композита с полимеризационной лампой",
    process: [
      { title: "Консультация и анализ", body: "Клинический осмотр, оценка прикуса, обсуждение Ваших пожеланий." },
      { title: "Подбор цвета и формы", body: "Выбор оттенков композита для дентинного и эмалевого слоёв." },
      { title: "Подготовка", body: "Очистка поверхности, изоляция коффердамом, адгезивная подготовка." },
      { title: "Послойное моделирование", body: "Полихромная стратификация с фотополимеризацией каждого слоя." },
      { title: "Финишная обработка и полировка", body: "Анатомическая микротекстура и естественный блеск." },
      { title: "Контроль и результат", body: "Визуальный контроль, проверка прикуса, передача." }
    ],
    aftercareTitle: "После лечения и уход",
    aftercare: [
      "Без периода восстановления – есть и говорить можно сразу",
      "Первые 24–48 часов: избегайте сильно красящих продуктов и напитков (кофе, красное вино, чай, карри, ягоды)",
      "Уход как за собственными зубами – чистка дважды в день, межзубная гигиена, регулярная профессиональная чистка",
      "Избегайте разгрызания льда и открытия упаковок передними зубами",
      "При бруксизме: индивидуальная защитная каппа"
    ],
    longevityTitle: "Срок службы",
    longevityBody: "При хорошей гигиене и регулярных профессиональных чистках прямые композитные реставрации служат до 20 лет. Композит можно повторно полировать, дополнять и точечно ремонтировать – без полной замены.",
    benefitsTitle: "Преимущества кратко",
    benefits: [
      { label: "1 визит", value: "Видимый результат сразу" },
      { label: "Без обточки", value: "100 % сохранение натурального зуба" },
      { label: "Послойное моделирование", value: "Естественный вид, неотличимый от настоящего зуба" },
      { label: "Обратимость", value: "Все будущие варианты лечения остаются открытыми" },
      { label: "Ремонтопригодность", value: "Небольшие коррекции без полной замены" },
      { label: "Справедливая цена", value: "Существенно доступнее лабораторных решений" }
    ],
    faqTitle: "Часто задаваемые вопросы",
    faq: [
      { q: "Это больно?", a: "Нет. Поскольку препарирование не требуется, в большинстве случаев анестезия не нужна." },
      { q: "Сколько длится приём?", a: "30–60 минут на один зуб. Полное обновление улыбки планируется за один день." },
      { q: "Будет ли заметно, что это не мой собственный зуб?", a: "При правильно выполненной послойной технике с дентинными и эмалевыми массами композит визуально неотличим от натуральной эмали." },
      { q: "Как ухаживать за восстановленными зубами?", a: "Так же, как за собственными зубами. Важна профессиональная чистка каждые 6 месяцев." },
      { q: "Меняет ли материал цвет со временем?", a: "Современный композит обладает высокой цветостабильностью. Незначительные поверхностные изменения, как правило, устраняются полировкой." },
      { q: "Сколько держится результат?", a: "До 20 лет при правильном уходе. Ремонт возможен в любое время, без замены всей реставрации." },
      { q: "Что если кусочек отколется?", a: "Мы выполняем точечный ремонт, не заменяя всю реставрацию." },
      { q: "Подходит ли это лечение мне?", a: "Это мы определяем на личной консультации. При выраженном стирании или нарушениях прикуса мы открыто обсудим наиболее подходящий метод." },
      { q: "Сколько это стоит?", a: "Зависит от количества зубов и сложности работы. Письменную смету Вы получаете до начала лечения." }
    ],
    ctaTitle: "Готовы к новой улыбке?",
    ctaBody: "Запишитесь на персональную консультацию. Мы выслушаем, проведём осмотр и честно скажем, что возможно.",
    ctaButton: "Записаться на консультацию онлайн",
    ctaCall: "Или позвоните нам"
  },
  legalNotice: {
    title: "Юридическая информация",
    german: {},
    english: {},
    spanish: {}
  }
};